import { graphql } from 'GQL/gql';

const CAPABILITY_SKILLS_CREATE = graphql(`
  mutation CAPABILITY_SKILLS_CREATE(
    $record: [CreateOneCapabilitySkillInput]!
    $policiesPreset: PoliciesPresetInput
  ) {
    capabilitySkillCreateMany(record: $record) {
      __typename
      recordId
      record {
        ...CapabilitySkillsFields
      }
    }
  }
`);

const CAPABILITY_SKILL_UPDATE = graphql(`
  mutation CAPABILITY_SKILL_UPDATE(
    $record: UpdateByIdCapabilitySkillInput!
    $policiesPreset: PoliciesPresetInput
  ) {
    capabilitySkillUpdateById(record: $record) {
      __typename
      recordId
      record {
        ...CapabilitySkillsFields
      }
    }
  }
`);

const CAPABILITY_SKILL_DELETE = graphql(`
  mutation CAPABILITY_SKILL_DELETE($_id: ID!) {
    capabilitySkillRemoveById(_id: $_id) {
      __typename
      recordId
    }
  }
`);

export { CAPABILITY_SKILL_DELETE, CAPABILITY_SKILL_UPDATE, CAPABILITY_SKILLS_CREATE };
